import { useMutation, useQueryClient } from "@tanstack/react-query";
import { restoreAllDepartments as apiRestoreAll } from "../../api/apiDepartments";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useRestoreAllDepartments() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: restoreAllDepartments, isPending: isRestore } = useMutation({
        mutationFn: (req) => apiRestoreAll(req),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["departments"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { restoreAllDepartments, isRestore };
}
